module.exports = __webpack_public_path__ + "media/images/banners/banner-pattern-f2678501bbd738ff0beda8829e0b14d6.png";